<template>

	<b-row>
		<b-col cols="12" xl="12">
			<transition name="slide">
				<b-card no-body>
					<div slot="header" class="d-flex justify-content-between custom-card-header">
						<h5 class="card-header-title">{{$t('contragent.title')}}</h5>

						<div class="card-header-actions">
							<div class="searchInCard">
								<b-input-group size="sm">
									<b-form-input v-model="filter" @keyup.enter="searchByName"
									size="sm" :placeholder="$t('contragent.filter')"/>
									<b-input-group-append>
										<b-button :disabled="!filter" @click="filter = ''">{{$t('contragent.clear')}}
										</b-button>
									</b-input-group-append>
								</b-input-group>
							</div>
							<b-link
								@click="showCreateUserModal({})"
								size="sm" variant="primary"
								v-if="$can('create/edit', 'contragent')"
							>
								<i class="fa fa-user-plus"
								   style="font-size: 1.4em;color: #53575B;margin-right: 3px;"></i>
							</b-link>

							<vs-dropdown vs-custom-content vs-trigger-click>
								<b-link href.prevent class="card-header-action btn-setting" style="font-size: 1.4em">
									<i class="fa fa-th"></i>
								</b-link>
								<vs-dropdown-menu class="columns-dropdown">
									<visible-columns :default-fields="computedColumns"
													 @result="columnListener"></visible-columns>
								</vs-dropdown-menu>
							</vs-dropdown>

						</div>
					</div>
					<b-card-body style="padding-top: 0;">
						<b-container fluid>
							<b-row>
								<b-container fluid class="p-0">
									<b-row class="justify-content-start">
										<b-col md="3" class="mb-2">
											<b-form-group
												class="mb-0" size="sm">
												<b-input-group class="shodowed-group">
													<b-form-select
														@change="categoryFilterChanged"
														:options="categoryOptions.items"
														:value-field="'id'"
														:text-field="'name'"
														v-model="categoryOptions.value"
														size="sm"
														id="categoryFilter">
														<template slot="first">
															<option :value="null" disabled>
																{{$t('contragent.search-category')}}
															</option>
														</template>
													</b-form-select>
													<b-input-group-append>
														<b-input-group-addon>
															<b-button type="button"
																	  size="sm"
																	  variant="outline-default"
																	  @click="clearCategoryFilter"
																	  v-b-tooltip.hover :title="$t('contragent.clear')">
																<i class="fa fa-close"></i>
															</b-button>
														</b-input-group-addon>
													</b-input-group-append>
												</b-input-group>
											</b-form-group>
										</b-col>
										<b-col md="3" class="mb-2">
											<b-form-group class="mb-0" size="sm">
												<b-input-group class="shodowed-group">
													<b-form-select
														@change="groupFilterChanged"
														:options="groupOptions.items"
														:value-field="'id'"
														:text-field="'name'"
														v-model="groupOptions.value"
														size="sm"
														id="groupFilter">
														<template slot="first">
															<option :value="null" disabled>
																{{$t('contragent.sarch-group')}}
															</option>
														</template>
													</b-form-select>
													<b-input-group-append>
														<b-input-group-addon>
															<b-button type="button"
																	  size="sm"
																	  variant="outline-default"
																	  @click="clearGroupFilter"
																	  v-b-tooltip.hover :title="$t('contragent.clear')">
																<i class="fa fa-close"></i>
															</b-button>
														</b-input-group-addon>
													</b-input-group-append>
												</b-input-group>
											</b-form-group>
										</b-col>
										<!-- DEPARTMENTS FOR FILTER -->
										<b-col md="3" class="mb-2 certificate-list">
											<multiselect
												v-model="selectedDepartments"
												:options="wholesaleDepartments"
												:multiple="true"
												track-by="id"
												:show-labels="false"
												:allow-empty="true"
												label="name"
												:placeholder="$t('promo-to-product.department')"
												class="multiselect-pricing"
											>
											</multiselect>
										</b-col>


<!--										&lt;!&ndash; Raionul FOR FILTER &ndash;&gt;-->
<!--										<b-col md="3" class="mb-2 certificate-list">-->
<!--											1-->
<!--											<multiselect-->
<!--												v-model="selectedRegions"-->
<!--												:options="getRaionulChildren.items"-->
<!--												:multiple="true"-->
<!--												track-by="id"-->
<!--												:show-labels="false"-->
<!--												:allow-empty="true"-->
<!--												label="name"-->
<!--												placeholder="Raionul"-->
<!--												class="multiselect-pricing"-->
<!--											>-->
<!--											</multiselect>-->
<!--										</b-col>-->
									</b-row>
								</b-container>

								<b-table class="generalTableClass table-responsive"
										 :key="$i18n.locale + 'table'"
										 :hover="true"
										 :striped="true" :bordered="true"
										 :small="true"
										 responsive="sm"
										 :items="contragents"
										 :fields="fieldsForContragents"
										 :current-page="currentPage"
										 :per-page="0" show-empty>

									<!-- EMPTY SLOT FOR TABLE -->
									<template slot="empty" slot-scope="scope">
										<h4>{{ $t('empty')}}</h4>
									</template>
									<!-- EMPTY SLOT FOR TABLE -->

									<template slot="id" slot-scope="row">
										<strong>{{paginate(row.index, currentPage, paramsForFilter.limit)}}</strong>
									</template>

									<template slot="departments" slot-scope="data">
										<template v-if="data.item.departmentDtos">
											<p v-for="(dep, index) in data.item.departmentDtos" :key="dep.id">
												<span><strong>{{ index + 1 }}.</strong> {{ dep.name }} </span>
											</p>
										</template>
									</template>

									<template slot="fullName" slot-scope="data">
										<strong>{{data.item.fullName}}</strong>
									</template>

<!--									<template slot="email" slot-scope="data">-->
<!--										<strong>{{data.item.email}}</strong>-->
<!--									</template>-->

									<template slot="phone" slot-scope="data">
										<strong>{{data.item.phone}}</strong>
									</template>

<!--									<template slot="mobile" slot-scope="data">-->
<!--										<strong>{{data.item.mobile}}</strong>-->
<!--									</template>-->

									<template slot="address" slot-scope="data">
										<strong>{{data.item.address}}</strong>
									</template>

<!--									<template slot="address2" slot-scope="data">-->
<!--										<strong>{{data.item.address2}}</strong>-->
<!--									</template>-->

									<template slot="countryName" slot-scope="data">
										<strong>{{data.item.countryName}}</strong>
									</template>

									<template slot="categoryName" slot-scope="data">
										<strong>{{data.item.categoryName}}</strong>
									</template>

									<template slot="groupName" slot-scope="data">
										<strong>{{data.item.groupName}}</strong>
									</template>

									<template slot="comment" slot-scope="data">
										<strong>{{data.item.comment}}</strong>
									</template>

									<template slot="status" slot-scope="data">
										<b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
									</template>
									<template slot="actions" slot-scope="data">

										<b-link :key="data.item.id + 'delete'" @click="onOpen(data.item.id)" :id="'popOverDelete'+data.item.id" v-if="$can('delete', 'contragent')">
											<i class="fa fa-trash"></i>
										</b-link>
										<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
										<b-popover :key="data.item.id + 'popover'" :target="'popOverDelete'+data.item.id" placement="auto" container="myContainer" :ref="'popover'+data.item.id" class="refDeleteConfirm">
											<template slot="title">
												<b-button @click="onClose(data.item.id)" class="close" aria-label="Close" style="margin-left: 5px">
													<span class="d-inline-block" aria-hidden="true">&times;</span>
												</b-button>
												{{$t('actions.deletetitle')}}
											</template>
											<div>
												<div class="row mt-1">
													<div class="col-6">
														<b-button variant="outline-danger" size="sm" block @click="onClose(data.item.id)">Yo'q</b-button>
													</div>
													<div class="col-6">
														<b-button variant="outline-success" size="sm" block @click="onOk(data.item.id)">Ha</b-button>
													</div>
												</div>
											</div>
										</b-popover>
										<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->

										<b-link @click="showCreateUserModal(data)" v-if="$can('create/edit', 'contragent')">
											<i class="fa fa-edit"></i>
										</b-link>

										<!-- BUTTON FOR MONEY TRANSFER BEGIN -->
										<b-link @click="contragentMoneyTransfer(data.item)"   v-if="$can('transfer', 'money')">
											<i class="fa fa-money"></i>
										</b-link>
										<!-- BUTTON FOR MONEY TRANSFER END -->
										<!-- BUTTON FOR GETTING SALDO BY CONTRAGENT_ID BEGIN -->
										<b-link @click="saldoButtonPressed(data)"
												v-if="$can('get', 'saldo')"
										>
											<i class="fa fa-file-text-o"></i>
										</b-link>
										<!-- BUTTON FOR GETTING SALDO BY CONTRAGENT_ID END -->
									</template>
								</b-table>
								<!-- PAGINATION -->
								<nav>
									<b-pagination size="sm" :total-rows="total" :per-page="perPage" v-model="currentPage" :prev-text="$t('pagination.prev')" :next-text="$t('pagination.next')" hide-goto-end-buttons/>
								</nav>
								<!-- PAGINATION -->

								<!-- LOADING SPINNER -->
								<div v-if="loadingForContragent" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
								<!-- LOADING SPINNER -->

								<!-- CREATE/EDIT CONTRAGENT MODAL BEGIN  -->
								<b-modal ref="createRoleModal"
										 hide-footer
										 ok-title="Save"
										 @shown="focusName('forContragent')"
										 :title="modalForAdding ? $t('contragent.create-title') : $t('contragent.update-title')">
									<b-alert
										v-if="createError"
										:show="dismissCountDown"
										dismissible
										style="margin-bottom: 10px;"
										variant="warning"
										size="sm"
										@dismissed="dismissCountDown=0"
										@dismiss-count-down="countDownChanged"
									>
										<p v-for="(message, index) in createContragentErrorMessage" :key="'message'+index">{{ $t( message ) }}</p>
									</b-alert>
									<contr-agent-form
										ref="contrAgentForm"
										@showNestedModal="showNestedModal"
										@close="closeCreateRoleModal"
										@reload="saveContragent"
										@gotOptionsForFilter="gotOptionsForFilter"
										:initial-for-not-filled="contrInputNotFilled"
										:for-contragent="true"
										:for-editing="!modalForAdding"
										:old-data="tempData"
										:parent-code="'item_brand'"
										:parent-name="'Brand'">

									</contr-agent-form>
								</b-modal>
								<!-- CREATE/EDIT CONTRAGENT MODAL END  -->

								<!-- CREATE REF MODAL BEGIN -->
								<b-modal body-class="nestedRefModal refModal"
										 ref="updateNestedRefModal"
										 id="modal-add"
										 @shown="focusName('forNestedModal')"
										 hide-footer
										 ok-title="Save"
										 :title="parentRefCode == 'CONTRAGENT_CATEGORY' ? 'Добавить новую категорию' : 'Добавить новую группу'">
									<create-ref-modal-content
										ref="createRefModalContent"
										:parent="'contragent'"
										:parentCode="parentRefCode"
										:propItem="itemRef"
										@closeUpdateRefModal="closeNestedUpdateRefModal">

									</create-ref-modal-content>
								</b-modal>
								<!-- CREATE REF MODAL END -->

								<!-- CONTRAGENT MONEY-TRANSFER MODAL BEGIN  -->
								<b-modal ref="moneyTransferModal" hide-footer ok-title="Save" size="lg" no-close-on-backdrop>
									<div slot="modal-header" class="posCustomModalHeader">
<!--										<h5 slot="modal-title" class="mb-0" v-if="!isSenderSelected">-->
<!--											{{$t('saldo.title')}}-->
<!--										</h5>-->
										<h5 slot="modal-title" class="mb-0" >
											Перевод денег - &nbsp;<b>{{ conter }}</b>
										</h5>
										<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeMoneyTransferModal">
											<i class="fa fa-times"></i>
										</button>
									</div>
									<b-tabs content-class="mt-3" fill pills>
										<b-tab title="Қарз" style="color: red"  active @click="tabs1"  :title-item-class="'tab-title-red'">
											<b-row>
												<b-col cols="12">
													<h5 style="color: red">Хурматли фойдаланувчи! Бу ойнада сиз мижозга қарзга берилган товарлар суммасини киритасиз</h5>
												</b-col>
											</b-row>
											<br>
											<hr>
											<b-row>
												<b-col sm="6">
													<label for="saldoDepartments">
														<span style="color: red;">*</span>{{$t('pricing.department')}}
														<span style="color: red;" v-if="departmentError">{{$t('pricing.errorDepartment')}}</span>
													</label>
													<multiselect
														:options="departmentsWithRequisite"
														:multiple="false"
														v-model="departmentForMoneyTransfer"
														track-by="id"
														label="name"
														id="saldoDepartments"
														:show-labels="false"
														:allow-empty="false"
														class="departmentForContragent"
													>
														<template slot="option" slot-scope="option">
															{{ option.option.name }} ({{ option.option.currencyCode ? option.option.currencyCode : 'no currency' }})
														</template>
													</multiselect>
												</b-col>
												<b-col sm="6">
													<label for="creditContragent"><span style="color: red;">*</span> Сумма денег</label>
													<b-form-input id="creditContragent"
																  size="sm"
																  type="number"
																  @focus="$event.target.select()"
																  v-model="aktForMoneyTransfer.creditContragent"
																  placeholder="Сумма денег"/>
												</b-col>
												<b-col sm="6">
													<label for="aktDate"><span style="color: red;">*</span> {{$t('incomes.date')}}</label><br>
													<date-picker v-model="aktForMoneyTransfer.aktDate"
																 lang="ru"
																 class="mb-3 pl-0"
																 id="aktDate"
																 placeholder="dd-mm-yyyy"
																 style="width: 100%"
																 valueType="format"
																 format="DD-MM-YYYY"
													></date-picker>
												</b-col>
												<b-col sm="6">
													<label for="aktOperation"><span style="color: red">*</span> Наименование операции</label>
													<b-form-textarea
														id="aktOperation"
														v-model="aktForMoneyTransfer.operation"
														placeholder="операция"
														rows="2"
														max-rows="4"
														class="mb-3"
													></b-form-textarea>
												</b-col>

											</b-row>
										</b-tab>
										<b-tab  title="Пул олиш" style="color: green" @click="tabs2" :title-item-class="'tab-title-green'">
											<b-row>
												<b-col cols="12">
													<h5 style="color: green">Хурматли фойдаланувчи! Бу ойнада сиз мижоздан қарзга берилган товарлар суммасини оласиз ёки депозит берган суммасини киритиб қўясиз</h5>
												</b-col>
											</b-row>
											<br>
											<hr>
											<b-row>
												<b-col sm="6">
													<label for="saldoDepartments">
														<span style="color: red;">*</span>{{$t('pricing.department')}}
														<span style="color: red;" v-if="departmentError">{{$t('pricing.errorDepartment')}}</span>
													</label>
													<multiselect
														:options="departmentsWithRequisite"
														:multiple="false"
														v-model="departmentForMoneyTransfer"
														track-by="id"
														label="name"
														id="saldoDepartments"
														:show-labels="false"
														:allow-empty="false"
														class="departmentForContragent"
													>
														<template slot="option" slot-scope="option">
															{{ option.option.name }} ({{ option.option.currencyCode ? option.option.currencyCode : 'no currency' }})
														</template>
													</multiselect>
												</b-col>
												<b-col sm="6">
													<label for="debitDepartment"><span style="color: red;">*</span> Сумма денег</label>
													<b-form-input id="debitDepartment"
																  size="sm"
																  type="number"
																  @focus="$event.target.select()"
																  v-model="aktForMoneyTransfer.creditDepartment"
																  placeholder="Сумма денег"/>
												</b-col>
												<b-col sm="6">
													<label for="aktDate"><span style="color: red;">*</span> {{$t('incomes.date')}}</label><br>
													<date-picker v-model="aktForMoneyTransfer.aktDate"
																 lang="ru"
																 class="mb-3 pl-0"
																 style="width: 100%"
																 id="aktDate"
																 placeholder="dd-mm-yyyy"
																 valueType="format"
																 format="DD-MM-YYYY"
													></date-picker>
												</b-col>
												<b-col sm="6">
													<label for="aktOperation"><span style="color: red">*</span>Наименование операции</label>
													<b-form-textarea
														id="aktOperation"
														v-model="aktForMoneyTransfer.operation"
														placeholder="операция"
														rows="2"
														max-rows="4"
														class="mb-3"
													></b-form-textarea>
												</b-col>

											</b-row>
										</b-tab >
									</b-tabs>
									<div class="model-actions mt-2" >
										<b-row class="align-items-center">
											<b-col cols="12" class="mb-3 mb-xl-0">
												<b-row class="d-flex justify-content-end">
													<b-col cols="4">
														<b-button block size="sm" type="button" @click="closeMoneyTransferModal" variant="outline-danger">{{
															$t('actions.cancel') }}
														</b-button>
													</b-col>
													<b-col cols="4">
<!--														<b-button block type="button" size="sm" @click="checkSender" variant="primary" v-if="!isSenderSelected">-->
<!--															Далее-->
<!--														</b-button>-->
														<b-button block type="button" size="sm" @click="createAkt" variant="primary">
															{{ $t('actions.save') }}
														</b-button>
													</b-col>
												</b-row>
											</b-col>
										</b-row>
									</div>
								</b-modal>
								<!-- CONTRAGENT MONEY-TRANSFER MODAL END  -->

								<!-- DEPARTMENT SELECT MODAL FOR SALDO BEGIN  -->
								<b-modal ref="saldoDepSelectModal" hide-footer ok-title="Save">
									<div slot="modal-header" class="posCustomModalHeader">
										<h5 slot="modal-title"
											class="mb-0"
										>
											Пожалуйста, выберите отдел
										</h5>
										<!-- SMALL LOADER -->
										<b-spinner v-if="loadingForContragent"
												   small
												   class="ml-2"
												   variant="primary"
												   label="Small Spinner"></b-spinner>
										<!-- SMALL LOADER -->
										<button
											type="button"
											class="close"
											data-dismiss="modal"
											aria-label="Close"
											@click="closeSaldoModal"
										>
											<i class="fa fa-times"></i>
										</button>
									</div>


									<b-alert
										v-if="saldoByYearError"
										:show="dismissCountDown"
										dismissible
										style="margin-bottom: 10px;"
										variant="warning"
										size="sm"
										@dismissed="dismissCountDown=0"
										@dismiss-count-down="countDownChanged"
									>
										<p>
											{{ saldoByYearErrorMessage }}
										</p>
									</b-alert>
									<div>
										<b-row>
											<b-col sm="6">
												<label for="saldoDepartmentSelect">
													<span style="color: red;">*</span>
													{{$t('pricing.department')}}
													<span style="color: red;"
														  v-if="departmentError"
													>
														{{$t('pricing.errorDepartment')}}
													</span>
												</label>
												<multiselect
													:options="departmentsWithRequisite"
													:multiple="false"
													v-model="departmentForMoneyTransfer"
													track-by="id"
													label="name"
													id="saldoDepartmentSelect"
													:show-labels="false"
													:placeholder="$t('promo-to-product.department')"
													:allow-empty="false"
													class="departmentForContragent"
												>
													<template slot="option" slot-scope="option">
														{{ option.option.name
														}} ({{ option.option.currencyCode ? option.option.currencyCode : 'no currency'
														}})
													</template>
												</multiselect>
											</b-col>
											<b-col sm="6">
												<label for="saldoYear">Год </label>
												<!--<date-picker v-model="aktForMoneyTransfer.aktDate"
															 lang="ru"
															 class="mb-3 pl-0"
															 placeholder="dd-mm-yyyy"
															 valueType="format"
															 format="DD-MM-YYYY"
												></date-picker>-->
												<date-picker v-model="saldoPayload.year"
															 lang="ru"
															 class="mb-3 pl-0"
															 id="saldoYear"
															 type="year"
															 placeholder="YYYY"
															 valueType="format"
															 format="YYYY"></date-picker>
											</b-col>

										</b-row>
									</div>
									<div class="model-actions">
										<b-row class="align-items-center">
											<b-col cols="12" class="mb-3 mb-xl-0">
												<b-row class="d-flex justify-content-end">
													<b-col cols="4">
														<b-button block size="sm" type="button" @click="closeSaldoModal" variant="outline-danger">{{
															$t('actions.cancel') }}
														</b-button>
													</b-col>
													<b-col cols="4">
														<b-button block type="button"
																  size="sm"
																  @click="getSaldoByContragent"
																  variant="primary"
														>
															Посмотреть сальдо
														</b-button>
													</b-col>
												</b-row>
											</b-col>
										</b-row>
									</div>
								</b-modal>
								<!-- DEPARTMENT SELECT MODAL FOR SALDO END  -->
							</b-row>
						</b-container>
					</b-card-body>
				</b-card>
			</transition>
		</b-col>
	</b-row>
</template>

<script>
	import {mapActions, mapGetters, mapState} from "vuex";
	import ContrAgentForm from './blocks/ContrAgentForm'
	import VisibleColumns from "../warehouse-management/goods/blocks/VisibleColumns";
	import CreateRefModalContent from './blocks/CreateRefModalContent'
	import Multiselect from 'vue-multiselect'
	import counter from "../applications/counter/index.vue";

	const itemInitial = {
		id: null,
		fullName: '',
		shortName: '',
		email: '',
		phone: '',
		mobile: '',
		address: '',
		inn: null,
		okonx: null,
		address2: '',
		countryId: null,
		countryName: '',
		categoryId: null,
		categoryName: '',
		groupId: null,
		groupName: '',
		comment: ''
	};
	const itemInitialRef = {
		id: null,
		parentId: null,
		parentName: '',
		code: '',
		name: '',
		value: '',
		sort: null
	};
	const aktInitial = {
		aktDate: '',
		operation: '',
		contragentId: null,
		contragentName: '',
		debitContragent: null,
		creditContragent: null,
		departmentId: null,
		departmentName: '',
		debitDepartment: null,
		creditDepartment: null,
	};
	const saldoPayloadInitial = {
		year: (new Date().getFullYear()).toString(),
		contragentId: null,
		departmentId: null
	};
	export default {
		name: 'Contragents',
		components: {
			ContrAgentForm,
			VisibleColumns,
			CreateRefModalContent,
			Multiselect
		},
		data() {
			return {
				conter:null,
				contragnet_id:null,
				tabs_id:'contragent',
				selectedDepartments: [],
				selectedRegions:[],
				/* DATA FOR ALERT WHEN DELETED 'NOT_ALLOWED' USER BEGIN */
				dismissCountDown: 4,
				/* DATA FOR ALERT WHEN DELETED 'NOT_ALLOWED' USER END */
				modalForAdding: false,
				item: Object.assign({}, itemInitial),
				tempData: Object.assign({}, itemInitial),
				itemRef: Object.assign({}, itemInitialRef),
				parentRefCode: '',
				aktForMoneyTransfer: Object.assign({}, aktInitial),
				saldoPayload: Object.assign({}, saldoPayloadInitial),
				selectedSender: null,
				isSenderSelected: false,
				transferSenderOptions: [
					{ text: this.$t('sale.contragent'), value: 'contragent' },
					{ text: this.$t('sale.shopName'), value: 'department' }
				],
				departmentForMoneyTransfer: null,
				departmentError: false,

				fieldsForContragents: [],
				filter: '',
				currentPage: 1,
				contrInputNotFilled: false,

				// FILTER DATA
				pageOptions: [1, 2, 3],
				categoryOptions: {
					items: [],
					value: null
				},
				groupOptions: {
					items: [],
					value: null
				},
				sampleForAttrId: {
					"field": "category.id",
					"value": "",
					"type": "long",
					"option": "EQUALS",
					"orderBy": "desc"
				},
			}

		},
		computed: {
			counter() {
				return counter
			},
			...mapState('departments', [
				'wholesaleDepartments'
			]),
			...mapGetters('contragents', [
				'contragents', 'total', 'perPage'
			]),
			...mapGetters('references', [
				'getGroupChildren', 'getCategoryChildren', 'getCountryChildren','getRaionulChildren'
			]),
			...mapState('contragents', [
				'loadingForContragent',
				'notAllowedError',
				'deleteContragentErrorMessage',
				'createError',
				'createContragentErrorMessage',
				'moneyTransferError',
				'moneyTransferErrorMessage',
				'saldoByYearError',
				'saldoByYearErrorMessage',
				'currentContragentForTransfer',
				'paramsForFilter'
			]),
			...mapState('departments', [
				'departmentsWithRequisite'
			]),
			...mapState(['isAdmin', 'isContragent' , 'userName']),
			computedColumns() {
				return [
					{
						key: 'id',
						label: '№',
						sortable: true,
						visible: true,
						changebale: true,
						class: 'width4'
					},
					{
						key: 'departments',
						label: this.$t('promo-to-product.department'),
						sortable: true,
						visible: true,
						changebale: true,
						class: 'width16_wordBreak'
					},
					{
						key: 'fullName',
						label: this.$t('incomes.block-unit.name'),
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'phone',
						label: this.$t('contragent.phone'),
						visible: true,
						changebale: true
					},
					{
						key: 'regionName',
						label: 'Регион',
						visible: true,
						changebale: true
					},
					{
						key: 'address',
						label: this.$t('contragent.address'),
						visible: true,
						changebale: true,
						class: 'width9_wordBreak'
					},
					{
						key: 'categoryName',
						label: this.$t('contragent.category-name'),
						sortable: true,
						visible: true,
						changebale: true
					},
					{
						key: 'groupName',
						label: this.$t('contragent.group-name'),
						sortable: true,
						visible: false,
						changebale: true
					},
					{
						key: 'bankAccount',
						label: this.$t('contragent.bank'),
						sortable: true,
						visible: true,
						changebale: true,
						class: 'width16_wordBreak'
					},
					{
						key: 'vatAccount',
						label: this.$t('contragent.ndc'),
						sortable: true,
						visible: false,
						changebale: true
					},
					{
						key: 'comment',
						label: this.$t('comment'),
						visible: true,
						changebale: true
					},
					{
						key: 'actions',
						label: this.$t('actions.title'),
						'class': 'table_actions',
						visible: true,
						changebale: true
					}

				]
			}
		},

		async mounted() {
			await this.fetchContragents(this.selectedDepartments);
			await this.fetchWholesaleDepartments();
		},
		created() {
			this.fieldsForContragents = this.filterColumns(this.computedColumns);
		},
		watch: {
			'filter': {
				async handler(newValue) {
					if(newValue == '') {
						await this.$store.commit('contragents/setContragentName',newValue)
						await this.fetchContragents(this.selectedDepartments);
					}
				}
			},
			'selectedDepartments': {
				deep: true,
				handler() {
					this.fetchContragents(this.selectedDepartments);
				}
			},
			'selectedRegions': {
				deep: true,
				async handler(newValue) {
					// GET FILTERED DATA
					await this.setRegions(this.selectedRegions)
					await this.fetchContragents(this.selectedDepartments);
				}
			},
			/* FOR TABLE HEADER TRANSLATION ISSUE */
			computedColumns (val) {
				this.fieldsForContragents = this.filterColumns(val);
			},
			/* FOR TABLE HEADER TRANSLATION ISSUE */

			currentPage: {
				async handler() {
					await this.setCurrentPage(this.currentPage);
					this.fetchContragents(this.selectedDepartments)
				}
			},

			/* WATCHERS FOR FILTER BEGIN */
			'categoryOptions.value': {
				handler(newVal) {
					if (!newVal) {
						this.categoryFilterChanged(null);
					}
				}
			},
			'groupOptions.value': {
				handler(newVal) {
					if (!newVal) {
						this.groupFilterChanged(null);
					}
				}
			},
			/* WATCHERS FOR FILTER END */
			'departmentForMoneyTransfer': {
				handler(newVal) {
					if (newVal) {
						this.$store.commit('contragents/setCurrentDepartmentForMoneyTransfer', newVal);
					} else {
						this.$store.commit('contragents/setCurrentDepartmentForMoneyTransfer', null);
					}
				}
			}
		},
		methods: {
			...mapActions('contragents', [
				'fetchContragents',
				'setCurrentPage', // receives currentPage
				'setParamForFilter', // receives fieldObj
				'deleteParamFromFilter', // receives fieldName
				'resetParamForFilter', // receives nothing; just call and it resets the filter
				'deleteContragentStore',
				'createContragentStore',
				'changeFieldsForTable',
				'createSaldoMoneyTransfer',
				'getSaldoList',
				'setRegions'
			]),
			...mapActions('departments', [
				'getDepartmentsForContragent', 'fetchWholesaleDepartments'
			]),
			async searchByName() {
				if(this.filter != ''){
					await this.$store.commit('contragents/setContragentName',this.filter)
					await this.fetchContragents(this.selectedDepartments);
				}
			},
			paginate(index, page_size, page_number) {
				--page_size;
				return (page_number * page_size) + index + 1;
			},
			focusName (forWhat) {
				if (forWhat == 'forContragent') {
					this.$refs.contrAgentForm.focusName();
				} else if (forWhat == 'forNestedModal') {
					this.$refs.createRefModalContent.focusName();
				}
			},
			/* POPOVER METHODS BEGIN */
			onOpen(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('open')
			},
			onClose(itemId) {
				let refName = 'popover' + itemId;
				this.$refs[refName].$emit('close')
			},
			async onOk(itemId) {
				this.onClose(itemId);
				await this.contragentDelete(itemId);
			},
			/* POPOVER METHODS END */

			countDownChanged(dismissCountDown) {
				if (dismissCountDown <= 1) {
					dismissCountDown = 3;
				}
				this.dismissCountDown = dismissCountDown
			},

			async saveContragent(boolean) {
				if (boolean) {
					this.$refs.createRoleModal.hide();
					await this.fetchContragents(this.selectedDepartments);

				} else {
					if (this.createError) {
						setTimeout(() => {
							this.$store.commit('contragents/createContragentError', {message: [], boolean: false})
						}, 4000)
					}
					this.contrInputNotFilled = true;
				}
			},

			closeNestedUpdateRefModal() {
				this.$refs.updateNestedRefModal.hide();
			},
			closeCreateRoleModal(boolean) {
				this.contrInputNotFilled = false;
				this.$refs.createRoleModal.hide();
			},
			showNestedModal(type) {
				if (type == 'Category') {
					this.parentRefCode = 'CONTRAGENT_CATEGORY';
					this.$refs.updateNestedRefModal.show();
				} else if (type == 'Group') {
					this.parentRefCode = 'CONTRAGENT_GROUPS';
					this.$refs.updateNestedRefModal.show();
				}else if(type == 'Raionul') {
					this.parentRefCode =  'Raionul'
					this.$refs.updateNestedRefModal.show();
				}
			},
			async contragentDelete(id) {
				await this.deleteContragentStore(id);
				if (this.notAllowedError) {
					setTimeout(() => {
						this.$store.commit('contragents/deleteContragentError', {message: '', boolean: false})
					}, 5000)
				}
				await this.fetchContragents(this.selectedDepartments);
			},

			async showCreateUserModal(data) {
				/* THIS IS TO TRIGGER WATCHER IN CONTRAGENT FORM */
				this.tempData.id = 1;
				/* THIS IS TO TRIGGER WATCHER IN CONTRAGENT FORM */
				this.tempData = Object.assign({}, itemInitial);
				if (this.$refs.contrAgentForm.contragentNotFilled) {
					this.$refs.contrAgentForm.contragentNotFilled = false;
				}
				this.contrInputNotFilled = false;
				if (data.item) {
					this.tempData = Object.assign({}, data.item);
					this.modalForAdding = false;

					this.$refs.createRoleModal.show();
				} else {
					this.tempData = Object.assign({}, itemInitial);
					this.modalForAdding = true;
					this.$refs.createRoleModal.show();
				}
			},
			tabs1(){
				this.tabs_id = "contragent"
				this.$forceUpdate()
				console.log(this.tabs_id)
				this.aktForMoneyTransfer.creditDepartment = ''
			},
			tabs2(){
				this.tabs_id = 'deparment'
				this.$forceUpdate()
				console.log(this.tabs_id)
				this.aktForMoneyTransfer.creditContragent = ''
			},
			contragentMoneyTransfer(data) {
				this.conter = data.fullName
				console.log(this.conter		)
				this.getDepartmentsForContragent();
				console.log(this.tabs_id)
				this.$forceUpdate()
				this.tabs_id = 'contragent'
				this.$refs.moneyTransferModal.show();
				this.aktForMoneyTransfer = Object.assign({}, aktInitial);
				this.aktForMoneyTransfer.contragentId = data.id
				this.contragnet_id = data.id
				// this.selectedSender = null;
				// this.isSenderSelected = false;
				// this.departmentForMoneyTransfer = null;
				// this.$store.commit('contragents/setCurrentContragentForTransfer', data.item);
				// this.currentContragentForTransfer = data.item;
				// this.$refs.moneyTransferModal.show();
			},
			closeMoneyTransferModal() {
				this.$store.commit('contragents/setCurrentContragentForTransfer', null);
				// this.currentContragentForTransfer = null;
				this.$refs.moneyTransferModal.hide();
			},
			closeSaldoModal() {
				// this.$store.commit('contragents/setCurrentContragentForTransfer', null);
				// this.currentContragentForTransfer = null;
				this.$refs.saldoDepSelectModal.hide();
			},
			async checkSender() {
				if (this.selectedSender) {
					this.isSenderSelected = true;
					await this.getDepartmentsForContragent();
					/*if (this.selectedSender == 'department') {
					}*/
				} else {
					this.isSenderSelected = false;
					this.$vs.notify({
						text: 'Выберите отправитель денег',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}
			},
			async createAkt() {
				console.log(this.selectedSender)
				if (this.tabs_id) {
					if (this.tabs_id === 'deparment') {
						if (this.departmentForMoneyTransfer &&
							this.aktForMoneyTransfer.creditDepartment > 0 &&
							this.aktForMoneyTransfer.aktDate.trim().length > 0 &&
							this.aktForMoneyTransfer.operation.trim().length > 0
							) {
							// this.aktForMoneyTransfer.contragentId = this.currentContragentForTransfer.id;
							this.aktForMoneyTransfer.departmentId = this.departmentForMoneyTransfer.id;
							this.aktForMoneyTransfer.debitContragent = this.aktForMoneyTransfer.creditDepartment;
							await this.createSaldoMoneyTransfer(this.aktForMoneyTransfer);
							if (!this.moneyTransferError) {
								this.closeMoneyTransferModal();
								this.$vs.notify({
									text: 'Операция выполнена успешно',
									color: 'success',
									icon: 'close',
									position: 'top-right'
								});
							} else {
								setTimeout(() => {
									this.$store.commit('contragents/createMoneyTransferError', {message: '', boolean: false})
								}, 4000)
							}
						} else {
							this.$vs.notify({
								text: 'Заполните все поле!',
								color: 'warning',
								icon: 'close',
								position: 'top-right'
							});
						}
					}
					else {
						if (this.departmentForMoneyTransfer &&
							this.aktForMoneyTransfer.creditContragent > 0 &&
							this.aktForMoneyTransfer.aktDate.trim().length > 0 &&
							this.aktForMoneyTransfer.operation.trim().length > 0
						) {
							// this.aktForMoneyTransfer.contragentId = this.currentContragentForTransfer.id;
							this.aktForMoneyTransfer.departmentId = this.departmentForMoneyTransfer.id;
							this.aktForMoneyTransfer.debitDepartment = this.aktForMoneyTransfer.creditContragent;
							await this.createSaldoMoneyTransfer(this.aktForMoneyTransfer);
							if (!this.moneyTransferError) {
								this.closeMoneyTransferModal();
								this.$vs.notify({
									text: 'Операция выполнена успешно',
									color: 'success',
									icon: 'close',
									position: 'top-right'
								});
							} else {
								setTimeout(() => {
									this.$store.commit('contragents/createMoneyTransferError', {message: '', boolean: false})
								}, 4000)
							}
						} else {
							this.$vs.notify({
								text: 'Заполните все поле!',
								color: 'warning',
								icon: 'close',
								position: 'top-right'
							});
						}
					}
				} else {
					this.isSenderSelected = false;
					this.$vs.notify({
						text: 'Выберите отправитель денег',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}
			},
			// saveAkt(){
			// 	if ()
			// },
			async saldoButtonPressed(data) {
				this.departmentForMoneyTransfer = null;
				this.$store.commit('contragents/setCurrentContragentForTransfer', data.item);
				// this.currentContragentForTransfer = data.item;
				this.$refs.saldoDepSelectModal.show();
				await this.getDepartmentsForContragent();
			},
			async getSaldoByContragent() {
				if(this.departmentForMoneyTransfer) {
					this.saldoPayload.departmentId = this.departmentForMoneyTransfer.id;
					this.saldoPayload.contragentId = this.currentContragentForTransfer.id;
					if (this.saldoPayload.year) {
						if (this.saldoPayload.year.length < 4) {
							this.saldoPayload.year = (new Date().getFullYear()).toString();
						}
					} else {
						this.saldoPayload.year = (new Date().getFullYear()).toString();
					}
					await this.getSaldoList(this.saldoPayload);
					if (!this.saldoByYearError) {
						this.$router.push({path: `/counterparties/${this.currentContragentForTransfer.id}/saldo`});
						this.closeSaldoModal();
					} else {
						setTimeout(() => {
							this.$store.commit('contragents/setSaldoByYearError', {message: '', boolean: false})
						}, 4000)
					}
				} else {
					this.$vs.notify({
						text: 'Выберите отдел',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}
			},
			filterColumns(columns = []) {
				return columns.filter(column => {
					if (column.visible) {
						return column
					}
				})
			},
			columnListener($event) {
				this.fieldsForContragents = this.filterColumns($event)
			},

			/* FILTER METHODS BEGIN */

			gotOptionsForFilter() {
				this.groupOptions = Object.assign({}, this.getGroupChildren);
				this.categoryOptions = Object.assign({}, this.getCategoryChildren);
			},

			/* CATEGORY FILTER FUNC */
			async categoryFilterChanged(categoryId) {
				let fieldName = 'category.id';
				if (categoryId) {
					this.sampleForAttrId.field = fieldName;
					this.sampleForAttrId.value = categoryId;

					this.deleteParamFromFilter(fieldName);
					let fieldObj = Object.assign({}, this.sampleForAttrId);
					this.setParamForFilter(fieldObj);
				} else {
					if (!this.groupOptions.value) {
						this.resetParamForFilter();
					} else {
						this.deleteParamFromFilter(fieldName);
					}
				}
				// GET FILTERED DATA
				await this.fetchContragents(this.selectedDepartments);
			},

			/* GROUP FILTER FUNC */
			async groupFilterChanged(groupId) {
				let fieldName = 'group.id';
				if (groupId) {

					this.sampleForAttrId.field = fieldName;
					this.sampleForAttrId.value = groupId;

					let fieldObj = Object.assign({}, this.sampleForAttrId);
					this.deleteParamFromFilter(fieldName);
					this.setParamForFilter(fieldObj);
				} else {
					if (!this.categoryOptions.value) {
						this.resetParamForFilter();
					} else {
						this.deleteParamFromFilter(fieldName);
					}
				}
				// GET FILTERED DATA
				await this.fetchContragents(this.selectedDepartments);
			},

			/* CLEARING FILTER */
			clearCategoryFilter() {
				this.categoryOptions.value = null;
			},
			clearGroupFilter() {
				this.groupOptions.value = null;
			}
			/* FILTER METHODS END*/
		} // METHODS END

	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
	.tab-title-red{
		color: #FF0000 !important;
	}
	.tab-title-green{
		color: green !important;
	}
	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}
	.form-group select {
		color: #000;
	}
	.posCustomModalHeader {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-between;

		.close {
			font-size: 14px;
		}
	}
</style>
